import Modal from 'libs/components/modal'

export default function(events_data) {
  const self = this;
  self.$el = $('#js-calendar-view');
  self.$fullCalendar = $('#js-calendar-container');
  self.$miniCalendar = $('#js-mini-calendar-container');
  self.$dialogue = $('#js-calendar-dialogue');
  self.$calendarSelector = $('#js-calendar-selector-clndr');

  self.events = ko.observableArray([]);
  self.enrollments = ko.observableArray([]);
  self.raw_event_data = null;
  self.selectedUsers = {};
  self.selectedUserNames = ko.observableArray([]);
  self.sidebarEvents = ko.observableArray();
  self.isEditingDate = ko.observable(false);
  self.isEditingDescription = ko.observable(false);
  self.isAddingAttendees = ko.observable(false);
  self.isEditingCalendar = ko.observable(false);
  self.isEditingRepeat = ko.observable(false);
  self.isViewingExisting = ko.observable(false);
  self.existingEvent = ko.observable();
  self.fullCalendarEvent = null;
  self.isChangingDateFromSideCalendar = false;
  self.accentColor = events_data.accent_color;
  self.coursesByStatus = [];
  self.clndr = null;

  self.getEventableType = () => {
    switch(self.existingEvent().eventable_type) {
      case "Lecture":
        return "Session"
      default:
        return self.existingEvent().eventable_type
    }
  }

  self.daysOfWeek = function(){
    return {
      '0': ko.observable(false),
      '1': ko.observable(false),
      '2': ko.observable(false),
      '3': ko.observable(false),
      '4': ko.observable(false),
      '5': ko.observable(false),
      '6': ko.observable(false)
    };
  };

  self.newEvent = {
    title: ko.observable().extend({required: true}),
    start: ko.observable().extend({required: true}),
    startTime: ko.observable(),
    startDate: ko.observable(),
    startHour: ko.observable(),
    startMeridian: ko.observable(),
    startHour12Format: ko.observable(),
    startMinute: ko.observable(),
    end: ko.observable().extend({required: true}),
    endTime: ko.observable(),
    endDate: ko.observable(),
    endHour: ko.observable(),
    endMeridian: ko.observable(),
    endHour12Format: ko.observable(),
    endMinute: ko.observable(),
    description: ko.observable(),
    all_day: ko.observable(false),
    location: ko.observable(),
    eventable_id: ko.observable(),
    selectedCourse: ko.observable(),
    useSelectedCourse: ko.observable(false),
    attendeeFilter: ko.observable(),
    possibleAttendees: ko.observableArray([]),
    recurrent_type: ko.observable(),
    recurrence_interval: ko.observable(),
    recurrence_times: ko.observable(),
    recurrence_end_date: ko.observable(),
    days_of_week: self.daysOfWeek(),
    repeatEndType: ko.observable('never'),
    id: ko.observable(null),
    useRepeat: ko.observable(false),
    repeatEditType: ko.observable(),
    has_polycom_call: ko.observable(false),
    video_call_url: ko.observable()
  };

  self.recurrenceTypeOptions = [
    { name: 'Weekly', id: 0},
    { name: 'Monthly', id: 1 }
  ];
  self.recurrenceIntervalOptions = [
    { name: 1, id: 1 },
    { name: 2, id: 2 },
    { name: 3, id: 3 },
    { name: 4, id: 4 }
  ];

  self.newEvent.start.subscribe(function(moment) {
    if (!moment) { return true; }
    self.newEvent.startDate(moment.format('ddd, MMM D'));
    self.newEvent.startTime(moment.format('hh:mm a'));
    self.newEvent.startHour(moment.hours() + (moment.minute() / 60));
    self.newEvent.startMeridian(moment.format('a'));
    self.newEvent.startHour12Format(moment.format('h'));
    self.newEvent.startMinute(moment.format('mm'));
  });

  self.newEvent.end.subscribe(function(moment) {
    if (!moment) { return true; }
    self.newEvent.endDate(moment.format('ddd, MMM D'));
    self.newEvent.endTime(moment.format('hh:mm a'));
    self.newEvent.endHour(moment.hours() + (moment.minute() / 60));
    self.newEvent.endMeridian(moment.format('a'));
    self.newEvent.endHour12Format(moment.format('h'));
    self.newEvent.endMinute(moment.format('mm'));
  });

  self.newEvent.attendeeFilter.subscribe(function(filter) {
    if (filter && filter.length > 0) {
      self.searchForPossibleAttendees(filter);
    } else {
      if (self.userSearchRequest) {
        self.userSearchRequest.abort();
        self.userSearchRequest = null;
      }
      self.resetPossibleAttendees();
    }
  });

  self.existingEvent.subscribe(function(event){
    if (!event) { return true; }
    self.formatExistingEventDescription();
  });

  self.newEvent.eventable_id.subscribe(function(){
    self.resetSelectedAttendees();
  });

  self.resetNewEvent = function() {
    self.newEvent.title('');
    self.newEvent.title.isModified(false);
    self.newEvent.id(null);
    self.newEvent.all_day(false);
    self.newEvent.start(null);
    self.newEvent.end(null);
    self.newEvent.location(null);
    self.newEvent.description(null);
    self.newEvent.eventable_id(null);
    self.newEvent.useRepeat(false);
    self.newEvent.repeatEditType(null);
    self.newEvent.useSelectedCourse(false);
    _.each(self.newEvent.days_of_week, function(observable, day){
      self.newEvent.days_of_week[day] = ko.observable(false);
    });
    self.newEvent.has_polycom_call(false);
    self.newEvent.video_call_url('');
    self.newEvent.recurrence_times(null);
    self.newEvent.recurrence_end_date(null);
    self.newEvent.recurrence_interval(1);
    self.newEvent.recurrent_type(0);
    self.newEvent.repeatEndType('never');
    self.newEvent.existingChildEvents = null;
    self.isEditingRepeat(false);
    self.isEditingDescription(false);
    self.isEditingCalendar(false);
    self.isAddingAttendees(false);
    self.isEditingDate(false);
    self.resetPossibleAttendees();
    self.resetSelectedAttendees();
  };

  self.bindData = function(events_data) {
    self.raw_event_data = events_data;
    self.resetNewEvent();
    const mappedEvents = ko.mapping.fromJS(events_data.events);
    self.events(mappedEvents());
    const mappedEnrollments = ko.mapping.fromJS(events_data.enrollments);
    self.enrollments(mappedEnrollments());
    self.resetSelectedAttendees();
    self.polycomEnabled = events_data.polycom_enabled;
    self.polycomConfiguredAdmin = events_data.polycom_configured_admin;
    self.groupCourses();
    self.isKadenze = Kadenze.isKadenze;
    self.isKannu = Kadenze.isKannu;
    self.setSidebarEvents();
  };

  self.groupCourses = function() {
    self.coursesByStatus = _.chain(self.enrollments()).groupBy(function(course){
      if (!course.status) {
        return 'draft';
      } else if (course.status() === 'published' && !course.is_active()) {
        return 'inactive';
      } else {
        return course.status();
      }
    }).map(function(courses, status){
      return {
        status: status,
        courses: courses
      };
    }).sortBy(function(obj){
      if (obj.status === 'published') {
        return -1;
      } else {
        return 0;
      }
    }).value();

    self.publishedCourses = _.findWhere(self.coursesByStatus, {status: 'published'});
  };

  self.initFullCalendar = function() {
    self.fullCalendar = self.$fullCalendar.fullCalendar({
      events: self.raw_event_data.events,
      eventClick: function(calEvent, jsEvent) {
        self.closeDialogue();
        self.closeExport();
        self.showExistingEvent(calEvent);
        self.showDialogue(jsEvent);
        self.fullCalendarEvent = calEvent;
        return false;
      },
      selectable: true,
      header: {
        left: 'today prev,next',
        center: 'title',
        right: 'agendaDay,agendaWeek,month cogButton'
      },
      eventLimit: true,
      eventLimitClick: 'popover',
      defaultView: 'month',
      nowIndicator: true,
      viewRender: function(view) {
        if (self.clndr && !self.isChangingDateFromSideCalendar) {
          self.closeDialogue();
          self.closeExport();
          self.clndr.setMonth(view.intervalStart.month());
          self.setSidebarEvents(view.intervalStart._d);
        }
        self.isChangingDateFromSideCalendar = false;
      },
      select: function(start, end, event) {
        self.closeDialogue();
        self.closeExport();
        self.resetNewEvent();
        if (start.hasTime()) {
          self.newEvent.start(start);
          self.newEvent.end(end);
        } else {
          self.newEvent.start(start);
          self.newEvent.end(end.subtract(30, 'minutes'));
          self.newEvent.all_day(true);
        }
        self.showDialogue(event);
        self.$fullCalendar.fullCalendar('unselect');
      },
      timezone: moment().zoneAbbr(),
      buttonIcons: {
        cog: 'kdnze-cog'
      },
      customButtons: {
        cogButton: {
          icon: 'cog',
          themeIcon: 'cog'
        }
      },
      eventRender: function(event, element, view){
        if (view.intervalUnit === 'month') {
          return $(JST['templates/calendar-event-view-month']({event: event}));
        }
        if (view.intervalUnit === 'week') {
          return $(JST['templates/calendar-event-view-week']({event: event}));
        }
        if (view.intervalUnit === 'day') {
          return $(JST['templates/calendar-event-view-day']({event: event}));
        }
      },
      views: {
        agendaWeek: {
          columnFormat: 'ddd D'
        }
      },
      height: 700
    });

    self.$exportButton = $('.fc-cogButton-button').popover({
      html: true,
      content: '<a href=\'javascript:;\' id=\'js-export-calendar\'>Export Calendar</a>',
      placement: 'bottom'
    }).on('shown.bs.popover', function(){
      const $export = $('#js-export-calendar');

      self.closeDialogue();

      $export.click(function() {
        $modal = Modal.for('calendar-export');

        $modal.find('.kd-form__copy-message').hide();

        const url = Kadenze.Routes.ical_path({ user_uid: self.raw_event_data.current_user_uid });
        $modal.find('#js-modal-export-url').val(window.location.origin + url);

        const clipboard = new Clipboard('#js-modal-export__copy-link');

        clipboard.on('success', function(){
          $modal.find('.kd-form__copy-message').show();
        });

        $modal.find('.js_ok').on('click', function() {
          $modal.modal('hide');
        });

        $modal.on('hidden.bs.modal', function(){
          clipboard.destroy();
        });
      });
    });
    const $calLeftArrow = $('.fc-prev-button');
    $calLeftArrow.html($('#js-left-button').html());
    $calLeftArrow.attr('aria-label', 'Previous');
    const $calRightArrow = $('.fc-next-button');
    $calRightArrow.html($('#js-right-button').html());
    $calRightArrow.attr('aria-label', 'Next');
    const $cogButton = $('.fc-cogButton-button');
    $cogButton.attr('aria-label', 'Settings Dropdown');
    $cogButton.attr('aria-expanded', 'false');

    $('body').on('shown.bs.popover', function(){
      $('.fc-cogButton-button').attr('aria-expanded', 'true');
    });
    $('body').on('hidden.bs.popover', function(){
      $('.fc-cogButton-button').attr('aria-expanded', 'false');
    });

    const $calAddEventBtn = $('.js-calendar-add-event-btn');
    $calAddEventBtn.on('click', function(event){
      self.closeDialogue();
      self.closeExport();
      self.resetNewEvent();
      self.newEvent.start(moment());
      self.newEvent.end(moment().add(30, 'minutes'));
      self.showDialogue(self.isPhone() ? null : event);
      self.$fullCalendar.fullCalendar('unselect');
    });
  };

  self.showDialogue = function(jsEvent) {
    self.$dialogue.show();

    if (jsEvent) {
      const dialogueWidth = self.$dialogue.width();
      const screenWidth = $(window).width();
      const screenHeight = $(window).height();
      const dialogueHeight = self.$dialogue.height();
      const pageX = jsEvent.originalEvent.pageX;
      const pageY = jsEvent.originalEvent.pageY;
      if (pageX < 10 && pageY < 10) {    // on enter key press, pagex and pagey are zero (or close to it in FF)
        self.$dialogue.css({ left: (screenWidth/2 - dialogueWidth/2) });
        self.$dialogue.css({ top: (screenHeight/2 - dialogueHeight / 2) });
      } else if (dialogueWidth + pageX > screenWidth) {
        self.$dialogue.css({ left: pageX - dialogueWidth });
        self.$dialogue.css({ top: (pageY - dialogueHeight / 2) });
      } else {
        self.$dialogue.css({ left: pageX });
        self.$dialogue.css({ top: (pageY - dialogueHeight / 2) });
      }
    }

    self.formatExistingEventDescription();
    Kadenze.UIUtil.scrollTo(self.$dialogue, 0.5);
    // if (!self.isPhone()) {
    //   if (self.$dialogue.find('#new_event_title').length > 0) {
    //     self.$dialogue.find('#new_event_title').focus();
    //   } else {
    //     self.$dialogue.find('a')[0].focus();
    //   }
    // } else {
    self.$dialogue.find('a')[0].focus();
    // }
  };

  self.formatExistingEventDescription = function() {
    const $description = $('.calendar-dialogue__description-text');
    const height = $description.height();
    const maxHeight = parseInt($description.css('max-height'), 10);
    if ((height < maxHeight) && self.existingEvent()) {
      self.existingEvent().shouldShowMore(false);
    }
  };

  self.resetTz = function(initialMoment) {
    if (initialMoment) {
      return moment(initialMoment.format('YYYY-MM-DD HH:mm:ss'));
    }
  };

  self.initMiniCalendar = function(){
    self.clndr = self.$miniCalendar.clndr({
      events: self.raw_event_data.events,
      template: $('#js-clndr-template').text(),
      multiDayEvents: {
        endDate: 'end',
        startDate: 'start'
      },
      daysOfTheWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      trackSelectedDate: true,
      selectedDate: new Date(),
      clickEvents: {
        // Fired whenever a calendar box is clicked. Returns a 'target' object
        // containing the DOM element, any events, and the date as a moment.js
        // object.
        click: function (target) {
          self.isChangingDateFromSideCalendar = true;
          self.closeDialogue();
          self.closeExport();
          self.$fullCalendar.fullCalendar('gotoDate', target.date);
          self.setSidebarEvents(target.date._d);
        },

        // Fires any time the month changes as a result of a click action.
        // Returns a moment.js object set to the correct month.
        onMonthChange: function (monthDate) {
          self.isChangingDateFromSideCalendar = true;
          self.closeDialogue();
          self.closeExport();
          self.$fullCalendar.fullCalendar('gotoDate', monthDate);
          self.setSidebarListHeight();
          self.setSidebarEvents(monthDate._d);
        }
      }
    });
  };

  self.closeDialogue = function() {
    self.$dialogue.hide();
    self.isViewingExisting(false);
    self.isEditingRepeat(false);
    self.isEditingDescription(false);
    self.isEditingCalendar(false);
    self.isAddingAttendees(false);
    self.isEditingDate(false);
    self.fullCalendarEvent = null;
  };

  self.closeExport = function() {
    if (self.$exportButton) {
      self.$exportButton.popover('hide');
    }
  };

  self.addPeople = function() {
    self.newEvent.attendeeFilter(null);
    self.isAddingAttendees(true);
  };
  self.stopAddingAttendees = function() {
    self.isAddingAttendees(false);
  };

  self.resetPossibleAttendees = function() {
    const selectedCourseID = self.setSelectedCourse();
    const possibleAttendees = _.where(self.raw_event_data.users, {course_id: selectedCourseID});
    if (self.newEvent.existingChildEvents) {
      _.each(self.newEvent.existingChildEvents, function(childEvent){
        if (_.where(possibleAttendees, {user_id: childEvent.user_id}).length === 0){
          possibleAttendees.push(childEvent);
        }

        const index = _.findIndex(self.raw_event_data.users, {user_id: childEvent.user_id});
        if (index === -1){
          console.log('adding to existing users');
          self.raw_event_data.users.push(childEvent);

          self.selectedUsers[childEvent.user_id] = ko.observable(true);
          self.selectedUsers[childEvent.user_id].subscribe(self.updateSelectedUserNames.bind(this, childEvent.user_id));
        }
      });
    }
    self.newEvent.possibleAttendees(possibleAttendees);
  };

  self.resetSelectedAttendees = function() {
    _.each(events_data.users, function(userEnrollment) {
      if (ko.isObservable(self.selectedUsers[userEnrollment.user_id])) {
        self.selectedUsers[userEnrollment.user_id](false);
      } else {
        self.selectedUsers[userEnrollment.user_id] = ko.observable(false);
        self.selectedUsers[userEnrollment.user_id].subscribe(self.updateSelectedUserNames.bind(this, userEnrollment.user_id));
      }
    });
    _.each(self.selectedUsers, function(obs, id){
      self.selectedUsers[id](false);
    });
  };

  self.updateSelectedUserNames = function(user_id) {
    const user = _.findWhere(self.raw_event_data.users, {user_id: user_id});
    const bool = self.selectedUsers[user_id]();
    if (bool) {
      self.selectedUserNames.push(user.name);
    } else {
      self.selectedUserNames.remove(user.name);
    }
  };

  self.setSelectedCourse = function() {
    const selectedCourseID = self.newEvent.eventable_id();
    if (selectedCourseID) {
      self.newEvent.selectedCourse(_.findWhere(self.raw_event_data.enrollments, {course_id: selectedCourseID}));
      if (!self.newEvent.selectedCourse().vmr) {
        self.newEvent.has_polycom_call(false);
      }
    } else {
      self.newEvent.selectedCourse(null);
      self.newEvent.has_polycom_call(false);
    }
    return selectedCourseID;
  };

  self.selectedCourseColor = function() {
    if (self.newEvent.selectedCourse()){
      return self.newEvent.selectedCourse().color;
    } else {
      return self.accentColor;
    }
  };

  self.checkForPolycomAllowed = function(data, event) {
    const hasStandardAdminConfig = self.polycomConfiguredAdmin && self.newEvent.selectedCourse().vmr;
    const hasIPForCourseVMR = self.newEvent.selectedCourse().vmr_is_ip;

    if (hasStandardAdminConfig || hasIPForCourseVMR) {
      return true;
    } else {
      Modal.for('confirmation-w-icon', {
        title: I18n.t('calendar.polycom_not_configured.modal_title'),
        body: I18n.t('calendar.polycom_not_configured.modal_body'),
        hideCancel: true,
        okBtnText: I18n.t('calendar.polycom_not_configured.modal_continue'),
        modalSize: 'md',
        iconClass: 'kf-warning'
      });

      event.originalEvent.stopImmediatePropagation();
      return false;
    }
  };

  self.editStart = function() {
    self.isEditingDate('start');
  };
  self.editEnd = function() {
    self.isEditingDate('end');
  };
  self.stopEditingDate = function() {
    const start = self.newEvent.start();
    const end = self.newEvent.end();
    if (start.isSameOrAfter(end)){
      // if start is before end, adjust accordingly
      if ((self.isEditingDate() === 'start') || self.newEvent.all_day()) {
        self.newEvent.end(moment(start).add(30, 'minutes'));
      } else if (self.isEditingDate() == 'end') {
        self.newEvent.start(moment(end).subtract(30, 'minutes'));
      }
    }
    self.toggleAllDayIfOver24Hours();
    self.isEditingDate(false);
  };

  self.isEditingDate.subscribe(function (attribute) {
    if (attribute) {
      const selectedDate = self.newEvent[attribute]();
      self.clndrSelector = self.$calendarSelector.clndr({
        template: $('#js-clndr-selector-template').text(),
        multiDayEvents: {
          endDate: 'end',
          startDate: 'start'
        },
        selectedDate: selectedDate._d,
        startWithMonth: selectedDate,
        trackSelectedDate: true,
        daysOfTheWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        clickEvents: {
          click: function (target) {
            const date = target.date;
            let editingDate = self.newEvent[self.isEditingDate()]();
            editingDate = editingDate.year(date.year()).month(date.month()).date(date.date());
            self.newEvent[self.isEditingDate()](editingDate);
          }
        }
      });
    }
  });

  self.updateHour = function(data, event) {
    const value = event.target.value.substring(0,2);
    event.target.value = value;
    let hour = parseInt(value, 10);
    hour = Math.min(event.target.max, hour);
    hour = Math.max(event.target.min, hour);
    if (hour !== 12 && self.newEvent[self.isEditingDate()+'Meridian']() === 'pm') {
      hour += 12;
    }
    const currentDate = self.newEvent[self.isEditingDate()]();
    currentDate.hour(hour);
    self.newEvent[self.isEditingDate()](currentDate);
  };
  self.updateMinute = function(data, event) {
    const value = event.target.value.substring(0,2);
    event.target.value = value;
    let minute = parseInt(value, 10);
    minute = Math.min(event.target.max, minute);
    minute = Math.max(event.target.min, minute);
    const currentDate = self.newEvent[self.isEditingDate()]();
    currentDate.minute(minute);
    self.newEvent[self.isEditingDate()](currentDate);
  };

  self.limitTimeLength = function(vm, event) {
    const selection = window.getSelection().toString();
    if (event.target.value.length >= 2 && (selection !== event.target.value)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  };

  self.setMeridianToAM = function(){
    const currentDate = self.newEvent[self.isEditingDate()]();
    let hour = currentDate.hour();
    hour -= 12;
    currentDate.hour(hour);
    self.newEvent[self.isEditingDate()](currentDate);
  };
  self.setMeridianToPM = function(){
    const currentDate = self.newEvent[self.isEditingDate()]();
    let hour = currentDate.hour();
    hour += 12;
    currentDate.hour(hour);
    self.newEvent[self.isEditingDate()](currentDate);
  };

  self.editDescription = function() {
    self.isEditingDescription(true);
  };
  self.stopEditingDescription = function() {
    self.isEditingDescription(false);
  };

  self.editRepeat = function() {
    const oldUseRepeat = self.newEvent.useRepeat();
    self.newEvent.useRepeat(true);
    self.isEditingRepeat(true);
    if (!oldUseRepeat) {
      _.each(self.newEvent.days_of_week, function(observable, day){
        self.newEvent.days_of_week[day] = ko.observable(false);
      });
    }
  };
  self.stopEditingRepeat = function() {
    self.isEditingRepeat(false);
  };

  self.editCalendar = function() {
    self.isEditingCalendar(true);
  };
  self.stopEditingCalendar = function() {
    self.setSelectedCourse();
    self.isEditingCalendar(false);
  };

  self.selectCalendar = function(enrollment) {
    self.newEvent.eventable_id(enrollment.course_id());
    self.stopEditingCalendar();
  };
  self.removeCalendar = function() {
    self.resetSelectedAttendees();
    self.newEvent.eventable_id(null);
    self.stopEditingCalendar();
  };

  self.save = function() {
    const data = self.toJSON();
    let method = 'post';
    let url = Kadenze.Routes.calendar_events_path();
    if (self.newEvent.id()) {
      method = 'put';
      url = Kadenze.Routes.calendar_event_path({id: self.newEvent.id()});
    }
    console.log(url, data);
    Kadenze.UIUtil.makeRequest(url, method, data, self.$dialogue,
      function() { //BeforeSave
        Kadenze.UIUtil.showLoadingIndicator(self.$dialogue);
      },
      function(event) { //Success
        event.start = $.fullCalendar.moment(event.start);
        if (event.end) {
          event.end = $.fullCalendar.moment(event.end);
        }
        if (self.fullCalendarEvent) {
          event._start = $.fullCalendar.moment(self.fullCalendarEvent._start);
          event._end = $.fullCalendar.moment(self.fullCalendarEvent._end || event.end);
        }
        event._id = event.id;
        window.oldMomentProto = $.extend({}, moment.fn);
        if (method === 'put') {
          self.$fullCalendar.fullCalendar('updateEvent', event);
          const index = _.findIndex(self.raw_event_data.events, {id: event.id});
          if (index > -1) {
            self.raw_event_data.events[index] = event;
            self.clndr.setEvents(self.raw_event_data.events);
          }
        } else {
          self.addEvent(event);
        }
        setTimeout(self.updateRecurrentEvents.bind(this, event), 50);

        const status = method === 'put' ? 'Updated' : 'Created';
        Kadenze.Notice.success({message: status + ' \'' + event.title + '\''});
      },
      function(xhr) { //Error
        Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
        Kadenze.UIUtil.hideLoadingIndicator(self.$dialogue);
      },
      function() { }); //Complete

  };

  self.updateRecurrentEvents = function(event) {
    const existingRepeatEvents = _.where(self.raw_event_data.events, {repeat_event_id: event.id});
    self.removeEvents(existingRepeatEvents);
    if (event.recurrent_events) {
      self.addEvents(event.recurrent_events);
    }
    self.setSidebarEvents();
    self.closeDialogue();
    Kadenze.UIUtil.hideLoadingIndicator(self.$dialogue);
  };

  self.addEvent = function(event) {
    self.$fullCalendar.fullCalendar('renderEvent', event, true);
    self.clndr.addEvents([event]);
    self.raw_event_data.events.push(event);
  };

  self.addEvents = function(events) {
    self.$fullCalendar.fullCalendar('addEventSource', events);
    self.clndr.addEvents(events);
    self.raw_event_data.events = self.raw_event_data.events.concat(events);
  };

  self.removeEvents = function(events) {
    const ids = _.pluck(events, 'id');
    _.each(ids, function(id){
      const index = _.findIndex(self.raw_event_data.events, {id: id});
      self.$fullCalendar.fullCalendar('removeEvents', id);
      if (index > -1) {
        self.raw_event_data.events.splice(index, 1);
        self.clndr.setEvents(self.raw_event_data.events);
      }
    });
  };

  self.toJSON = function() {
    const event = self.newEvent;
    const calendarEvent = {
      title: event.title(),
      start_date: self.resetTz(event.start()).format(),
      end_date: self.resetTz(event.end() || event.start()).format(),
      all_day: event.all_day(),
      location: event.location(),
      description: event.description(),
      video_call_url: event.video_call_url(),
      has_polycom_call: event.has_polycom_call()
    };
    const data = {calendar_event: calendarEvent};
    if (event.eventable_id()) {
      calendarEvent.eventable_id = event.eventable_id();
      calendarEvent.eventable_type = 'Course';
      if (event.useSelectedCourse()) {
        calendarEvent.calendarable_id = event.eventable_id();
        calendarEvent.calendarable_type = 'Course';
      } else {
        self.setSelectedCourse();
        calendarEvent.calendarable_id = event.selectedCourse().id;
        calendarEvent.calendarable_type = 'Enrollment';
      }
    } else {
      calendarEvent.calendarable_id = self.raw_event_data.current_user_id;
      calendarEvent.calendarable_type = 'User';
      calendarEvent.eventable_id = null;
      calendarEvent.eventable_type = null;

      // Not sure why these were being set to null as it makes it impossible to save
      // video call info
      //
      // calendarEvent.video_call_url = null;
      // calendarEvent.has_polycom_call = false;

    }
    calendarEvent.days_of_week = ko.mapping.toJS(event.days_of_week);
    if (event.useRepeat()) {
      calendarEvent.recurrent_type = event.recurrent_type();
      calendarEvent.recurrence_interval = event.recurrence_interval();
      const repeatEndType = event.repeatEndType();
      if (repeatEndType == 'date') {
        calendarEvent.recurrence_end_date = moment(event.recurrence_end_date())._d;
        calendarEvent.recurrence_times = null;
      } else if (repeatEndType == 'times') {
        calendarEvent.recurrence_times = event.recurrence_times();
        calendarEvent.recurrence_end_date = null;
      }
    } else {
      calendarEvent.recurrent_type = null;
      calendarEvent.recurrence_interval = null;
      calendarEvent.recurrence_times = null;
      calendarEvent.recurrence_end_date = null;
    }
    if (event.repeatEditType()) {
      data.repeat_edit_type = event.repeatEditType();
    }
    const userIds = _.chain(self.selectedUsers)
      .map(function(selected, userId){
        return [selected(), userId];
      }).filter(function(group){
        return group[0];
      }).map(function(group){
        return group[1];
      }).value();
    data.user_ids = userIds;

    return data;
  };

  self.updateDateHour = function(event, slider) {
    const value = slider.value;
    let currentDate = self.newEvent[self.isEditingDate()]();
    currentDate = currentDate.hour(value);
    currentDate = currentDate.minute((value % 1) * 60);
    self.newEvent[self.isEditingDate()](currentDate);
    return true;
  };

  self.setSidebarEvents = function(startDate) {
    if (!startDate) {
      startDate = new Date();
      startDate.setHours(0,0,0,0);
    }
    const todayMoment = moment().startOf('day');
    const nowTime = startDate.getTime();
    const _sidebarEvents = _.chain(self.raw_event_data.events)
      .uniq('id')
      .sortBy(function(event) {
        event.startDate = new Date(event.start);
        return event.startDate.getTime();
      })
      .filter(function(event){
        return event.startDate.getTime() >= nowTime;
      }).groupBy(function(event){
        const start = moment(event.start);
        let dateString = '';
        event.startTime = start.format('h:mm a');
        if (moment(event.startDate).startOf('day').isSame(todayMoment)) {
          dateString += 'Today';
        } else {
          dateString += start.format('dddd');
        }
        return dateString + start.format(', MMMM D YYYY');
      }).map(function(events, dateString){
        return {
          dateString: dateString,
          events: events
        };
      }).value();
    self.sidebarEvents(_sidebarEvents);
  };

  self.showExistingEvent = function(calendarEvent) {
    calendarEvent = self.formatExistingEvent(calendarEvent);
    self.existingEvent(calendarEvent);
    self.isViewingExisting(true);

    if (Kadenze.isKannu) {
      const $attendees = $('.calendar-dialogue__existing-attendees');
      const url = Kadenze.Routes.calendar_event_path({id: calendarEvent.id});
      const request = new Kadenze.AjaxRequest({
        url: url,
        type: 'GET'
      });
      Kadenze.UIUtil.showLoadingIndicator($attendees);
      request.done(function(newCalendarEvent) {
        self.formatExistingEvent(newCalendarEvent);
        self.existingEvent(newCalendarEvent);
      });
      request.complete(function() {
        Kadenze.UIUtil.hideLoadingIndicator($attendees);
      });
    }
  };

  self.formatExistingEvent = function(existingEvent) {
    const isEnrollment = existingEvent.calendarable_type === 'Enrollment';
    const hasInstructorEnrollment = !!_.findWhere(self.raw_event_data.enrollments,{id: existingEvent.calendarable_id, enrollment_type: 'instructor'});
    const hasNoParent = !existingEvent.parent_event_id;
    const isPersonalEvent = existingEvent.calendarable_type === 'User';
    if (existingEvent.eventable_attribute) {
      existingEvent.isEditable = false;
    } else if (!hasNoParent) {
      existingEvent.isEditable = false;
    } else if (isPersonalEvent || (isEnrollment && (hasInstructorEnrollment || hasNoParent))) {
      existingEvent.isEditable = true;
    } else {
      existingEvent.isEditable = false;
    }
    existingEvent.start = moment(existingEvent.start);
    if (existingEvent.end) {
      existingEvent.end = moment(existingEvent.end);
    }
    existingEvent.showMore = ko.observable(false);
    existingEvent.shouldShowMore = ko.observable(true);
    return existingEvent;
  };

  self.showMoreDescription = function() {
    self.existingEvent().showMore(true);
  };
  self.showLessDescription = function() {
    self.existingEvent().showMore(false);
  };

  self.editExistingEvent = function() {
    const existing = self.existingEvent();
    if (existing.recurrent_type || existing.repeat_event_id) {
      const $modal = Modal.for('recurrent-event-edit');

      $modal.find('.js_cancel').on('click', function() {
        $modal.modal('hide');
      });

      $modal.find('.js_all_events').on('click', function() {
        self.setRepeatEditType('all', $modal);
      });
      $modal.find('.js_following_events').on('click', function() {
        self.setRepeatEditType('following', $modal);
      });
      $modal.find('.js_only_event').on('click', function() {
        self.setRepeatEditType('only', $modal);
      });
    } else {
      self.setNewEventFromExisting();
    }
  };

  self.setRepeatEditType = function(type, $modal) {
    self.newEvent.repeatEditType(type);
    $modal.modal('hide');
    self.setNewEventFromExisting();
  };

  self.setNewEventFromExisting = function() {
    const existing = self.existingEvent();
    const attrs = ['title', 'start', 'end', 'all_day', 'location', 'eventable_id',
      'description', 'recurrence_times', 'recurrence_interval', 'recurrence_end_date',
      'recurrent_type', 'id', 'has_polycom_call', 'video_call_url'];
    _.each(attrs, function(attr){
      let value = existing[attr];
      if (ko.isObservable(value)) {
        value = value();
      }
      self.newEvent[attr](value);
    });
    if (self.newEvent.all_day()){
      self.newEvent.end(self.newEvent.end() || self.newEvent.start());
    }
    _.each(self.newEvent.days_of_week, function(observable, key) {
      if (existing.days_of_week && existing.days_of_week[key]){
        self.newEvent.days_of_week[key](existing.days_of_week[key]);
      } else {
        self.newEvent.days_of_week[key](false);
      }
    });
    if (existing.recurrence_end_date) {
      self.newEvent.repeatEndType('date');
    } else if (existing.recurrence_times) {
      self.newEvent.repeatEndType('times');
    } else {
      self.newEvent.repeatEndType('never');
    }
    if (existing.recurrent_type) {
      self.newEvent.useRepeat(true);
    }
    if (existing.child_events) {
      self.newEvent.existingChildEvents = existing.child_events;
      _.each(self.selectedUsers, function(isSelected, userId){
        if (_.findWhere(existing.child_events, {user_id: Number(userId)})) {
          self.selectedUsers[userId](true);
        } else {
          self.selectedUsers[userId](false);
        }
      });
    } else {
      self.newEvent.existingChildEvents = null;
    }

    self.resetPossibleAttendees();

    self.isViewingExisting(false);

    self.$dialogue.find('#event-video_call_url').focus();
    self.$dialogue.find('#event-video_call_url').blur();
    self.$dialogue.find('#event-location').focus();
    self.$dialogue.find('#event-location').blur();
    self.$dialogue.find('#new_event_title').focus();
  };

  self.setAttendanceYes = function() {
    self.setAttendanceStatus('yes');
  };
  self.setAttendanceNo = function() {
    self.setAttendanceStatus('no');
  };
  self.setAttendanceMaybe = function() {
    self.setAttendanceStatus('maybe');
  };
  self.setAttendanceStatus = function(status) {
    const existing = self.existingEvent();
    existing.attendance_status = status;
    self.existingEvent(existing);

    const url = Kadenze.Routes.calendar_event_path({id: existing.id});
    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'PUT',
      data: {
        calendar_event: {
          attendance_status: status
        }
      }
    });
    request.done(function() {
      Kadenze.Notice.success({message: 'Updated attendance successfully.'});
    });
  };

  self.destroy = function() {
    const $modal = Modal.for('confirmation-w-icon', {
      title: I18n.t('calendar.delete_event_title'),
      cancelBtnText: I18n.t('calendar.cancel'),
      body: '',
      okBtnText: I18n.t('calendar.delete_event'),
      layoutType: 'icon',
      iconClass: 'kf-warning'
    });

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function() {
      $modal.modal('hide');

      const id = self.newEvent.id();
      const data = {};
      if (self.newEvent.repeatEditType()) {
        data.repeat_edit_type = self.newEvent.repeatEditType();
      }
      const url = Kadenze.Routes.calendar_event_path({id: id}, data);
      const request = new Kadenze.AjaxRequest({
        url: url,
        type: 'DELETE'
      });
      Kadenze.UIUtil.showLoadingIndicator(self.$dialogue);
      request.done(function(data) {
        _.each(data.removed_ids, function(id) {
          self.removeEvent(id);
        });
        self.setSidebarEvents();
        self.closeDialogue();
      });
      request.complete(function() {
        Kadenze.UIUtil.hideLoadingIndicator(self.$dialogue);
      });
    });
  };

  self.removeEvent = function(id) {
    self.$fullCalendar.fullCalendar('removeEvents', [id]);
    const index = _.findIndex(self.raw_event_data.events, {id: id});
    if (index > -1) {
      self.raw_event_data.events.splice(index, 1);
      self.clndr.setEvents(self.raw_event_data.events);
    }
  };

  self.initEscapeKey = function(){
    $(document).keyup(function(event){
      if (event.keyCode === 27) {
        self.closeDialogue();
        self.closeExport();
      }
    });
  };

  self.existingEventVideoCallURL = function() {
    const event = self.existingEvent();
    if (event.has_polycom_call) {
      return Kadenze.Routes.polycom_calendar_event_path({id: event.id});
    } else {
      let url = event.video_call_url;
      if (url.indexOf('http') === -1) {
        url = 'http://' + url;
      }
      return url;
    }
  };

  self.searchForPossibleAttendees = function(filter) {
    // const $attendees = $('.calendar-attendees__list');
    // search for all users with personal calendar events
    if (self.userSearchRequest) {
      self.userSearchRequest.abort();
      self.userSearchRequest = null;
    }
    const url = Kadenze.Routes.user_search_calendar_events_path({query: filter});
    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET'
    });
    self.userSearchRequest = request;
    request.done(function(data) {
      const courseId = self.newEvent.eventable_id();
      _.chain(data.users).each(function(user){
        if (!self.selectedUsers[user.user_id]) {
          self.raw_event_data.users.push(user);
          self.selectedUsers[user.user_id] = ko.observable(false);
          self.selectedUsers[user.user_id].subscribe(self.updateSelectedUserNames.bind(this, user.user_id));
        }
        const courseEnrollment = _.findWhere(self.raw_event_data.users, {course_id: courseId, user_id: user.user_id});
        if (courseEnrollment) {
          console.log('found enrollment: ', courseEnrollment);
          user.filterEnrollment = courseEnrollment;
        }
      }).sortBy(function(user){
        return user.filterEnrollment ? 0 : 1;
      }).value();
      self.newEvent.possibleAttendees(data.users);
      self.userSearchRequest = null;
    });
  };

  self.viewEventFromSidebar = function(id) {
    if (!self.isPhone()) { return false; }
    const event = _.findWhere(self.raw_event_data.events, {id: id});
    self.$dialogue.css({
      height: window.screen.height,
      width: window.screen.width
    });
    self.showExistingEvent(event);
    self.showDialogue();
    // console.log(event);
  };

  self.goToToday = function() {
    self.clndr.options.selectedDate = moment().format('YYYY-MM-DD');
    self.clndr.today();
    self.clndr.render();
  };

  self.initMobileViews = function() {
    if (!self.isPhone()) { return false; }
    self.setSidebarListHeight();

    $('#js-calendar-container').hide();
  };

  self.setSidebarListHeight = function() {
    if (!self.isPhone()) { return false; }
    const $sidebarCalendar = $('#js-mini-calendar-container');
    const bottomOfCalendar = $sidebarCalendar.offset().top + $sidebarCalendar.height();
    // const bottomToolbarHeight = $('.calendar-sidebar__mobile-toolbar').height();
    const bottomToolbarHeight = 60;

    const listHeight = window.innerHeight - bottomOfCalendar - bottomToolbarHeight;
    $('.calendar-sidebar-list').css({height: listHeight});
  };

  self.toggleAllDayIfOver24Hours = function() {
    const start = self.newEvent.start();
    const end = self.newEvent.end();
    if (!start || !end)
      return true;
    const duration = moment.duration(end.diff(start));
    const hours = duration.asHours();
    if (hours >= 24) {
      self.newEvent.all_day(true);
    }
  };

  self.allDaysOfWeekEmpty = function() {
    let allFalse = true;
    _.each(self.newEvent.days_of_week, function(observable){
      if (observable()) {
        allFalse = false;
      }
    });
    return allFalse;
  };

  // If the last 'day of week' is unchecked, then
  // turn 'repeat' off entirely. If one is re-checked,
  // re-enable 'repeat'
  self.resetRepeatIfEmpty = function() {
    const allFalse = self.allDaysOfWeekEmpty();
    if (self.newEvent.useRepeat() && allFalse) {
      self.newEvent.useRepeat(false);
    } else if (!self.newEvent.useRepeat() && !allFalse) {
      self.newEvent.useRepeat(true);
    }
    return true;
  };

  self.isPhone = function() {
    return Modernizr.touch && is.not.tablet();
  };

  self.initUI = function() {
    self.initFullCalendar();
    self.initEscapeKey();
    self.initMobileViews();
    self.initMiniCalendar();
  };

  const __construct = function(that) {
    that.bindData(events_data);
  }(this);
}

